
const ContactBoxes = ({ contactUsInfo }) => {
    // console.log(contactUsInfo.admin.address);
    return (
        <div className="row justify-content-center">
            <div className="col-xl-4 col-sm-6 mb-4">
                <div className="contact-box text-center">
                    <i className="fal fa-map-marker-alt"></i>
                    <p className="address">{contactUsInfo?.admin.address}</p>
                </div>
            </div>
            <div className="col-xl-4 col-sm-6 mb-4">
                <div className="contact-box text-center">
                    <i className="fal fa-phone"></i>
                    <p className="phone">{contactUsInfo?.admin.phone}</p>
                </div>
            </div>
            <div className="col-xl-4 col-sm-6 mb-4">
                <div className="contact-box text-center">
                    <i className="fal fa-envelope"></i>
                    <p className="mail">{contactUsInfo?.admin.email}</p>
                </div>
            </div>
        </div>
    )
}

export default ContactBoxes;